import { Flex } from '@chakra-ui/react';
import TrackerSummary from './TrackerSummary.jsx';

export default function OrderSummary() {
  return (
    <Flex direction="column" gap={2}>
      <TrackerSummary showNotificationPrefs={false} />
    </Flex>
  );
}
